export default {
  AIM_TYPE_ABSENCE: 1,
  AIM_TYPE_PRESENCE: 2,
  BEHAVIOUR_TYPE_SHORT: 1,
  BEHAVIOUR_TYPE_LONG: 2,
  INTERVAL_DURATION_UNIT_MINUTES: 1,
  INTERVAL_DURATION_UNIT_SECONDS: 2,

  ENTITY_TYPE: 'interactive-session'

};


// WEBPACK FOOTER //
// ./src/modules/dro/Constants.js